interface DotProps {
  size?: 8 | 10;
}
const Dot: React.FC<DotProps> = ({ size = 10 }) => {
  const sizeClass = size === 8 ? 'w-2 h-2' : 'w-2.5 h-2.5';
  return <div className={`${sizeClass} bg-black rounded-full`} />;
};

interface RenderDotsProps {
  count: number;
  groupSpacing?: number;
  dotSize?: 8 | 10;
}

export const renderDots = ({ count, groupSpacing, dotSize = 10 }: RenderDotsProps) => {
  const groups: React.ReactNode[] = [];
  for (let i = 0; i < count; i += 4) {
    const groupDots: React.ReactNode[] = [];
    const groupSize = Math.min(4, count - i);
    for (let j = 0; j < groupSize; j++) {
      groupDots.push(<Dot key={j} size={dotSize} />);
    }
    groups.push(
      <div key={i} className="flex items-center gap-x-[6px]">
        {groupDots}
      </div>
    );
  }

  const containerStyle: React.CSSProperties = {
    display: 'flex',
    alignItems: 'center',
  };

  if (groupSpacing && groupSpacing > 0) {
    containerStyle.gap = `${groupSpacing}px`;
  }

  const defaultGapClass = !(groupSpacing && groupSpacing > 0) ? 'gap-x-[6px]' : '';

  return (
    <div style={containerStyle} className={`flex items-center ${defaultGapClass}`.trim()}>
      {groups}
    </div>
  );
};
